import { chartType } from '@/components/ChartGenerator/DragChart/types'
import {v4} from 'uuid'
 import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js'
 import { CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js'
import {THREE} from 'three-edit-cores'

export class LayerM{
  id:string=v4();
  name:string='';
  sub:string='';
  value:[Array,Object]=null;
  showTitle:Boolean=true;
  type:stirng='nums';
  fontSize:number=1 ; //em
  color:string='';
  bgColor:string='';
  radius:number=0;
  borderWidth:number=1;
  borderColor:string='#fff';
  xalign:string='left';
  yalign:string='top';
  x:number=0;
  y:number=0;
  width:number=300;
  height:number=200;

  bindType:Boolean=false // true 时为mqtt
  bindDevice:Object={device:'',devicevar:''}
  bindUrl:Object={method:'popwin',url:'',loop:0}
  constructor()
}

//数字展示框
export interface NumsModel {
  value: [String, Number]
  name: String
  alarm: Number
  unit: String
}

export function convert2d3d(mesh,use3d){
    var obj;
    if(mesh.isCSS2DObject&&use3d){
      var obj=new CSS3DObject(mesh.element)

    }else if(mesh.isCSS3DObject&&use3d==false){
      var obj=new CSS2DObject(mesh.element)
    }
    if(obj){
      obj.position.copy(mesh.position)
      obj.scale.copy(mesh.scale)
      mesh=obj
    }
  }
export function getIcon(icontype:String){

    if(svgIcons.hasOwnProperty(icontype)){
        return svgIcons[icontype]
      }else{
        return ''
      }
}
export function getAlarmColor(alarm:Number){
     return Alarm.color[alarm]
}

export const Alarm={
  color:['#13c2c2','#fbbd08','#f37b1d','#e54d42'],
  bgclass:['','bg-yellow','bg-orange','bg-red'],
  textclass:['','text-yellow','text-orange','text-red'],
  text:['正常','提醒','严重','危急']
}

export const defFormat={
  domtype:'input',
  name:'名称',
  required:false,
  data:[],
  desc:'',
  validate:'success' ,//'success' 'warning' 'error' 'validating'
  min:0,
  max:100,
  step:1,
  map: { name: 'text', value: 'id' },
  change:null
}

export class CustomMould{
  name:String=''
  label:String=''
  params:Object={use3d:false}
  format:Object={}
  constructor(_name:String,_label:String,_param:Object=null){
    this.name=_name
    this.label=_label

    if(!_param){
      this.params=new LayerM()
    }else{
      this.params=_param
    }
  }
  create(storage:Object){
    return null
  }
  getPanel(folder,mesh:Object=null){
    Object.keys(this.format).forEach(key=>{
        var o=this.format[key]
        var it= Object.assign({},defFormat,o)
        var that=this
        if(it.domtype=='number'){
          folder.add(mesh.userData.params,key).min(it.min).max(it.max).step(it.step).name(it.name).onChange(v=>{
            if(mesh&&it.change){
              it.change(mesh,v)
            }
          })
        }else if(it.domtype=='select'){
          var ar={}
          if(it.data){
            if(Array.isArray(it.data)){
                it.data.forEach(f => {
                  if(typeof(f)!='object'){
                    ar[f]=f
                  }else{
                    ar[f[it.map.name]]=f[it.map.value]
                  }
                });
            }else{
              ar=Object.keys(it.data)
            }
          }
          folder.add(mesh.userData.params,key,ar).name(it.name).onChange(v=>{
            if(mesh&&it.change){
              it.change(mesh,v)
              mesh.userData.params=that.params
            }
          })
        }else{
          folder.add(mesh.userData.params,key).name(it.name).onChange(v=>{
            if(mesh&&it.change){
              it.change(mesh,v)
              mesh.userData.params=that.params
            }
          })
        }
    })

  }
  initPanel(folder){
    //this.getPanel(folder)
  }
  createPanel(mesh, folder){
    this.getPanel(folder,mesh)
  }
  setStorage(mesh, storage){
    this.params=storage.params
    mesh.userData.params=storage.params
     //mesh.userData.bindType------false:以HTTP接口，true:接收mqtt
    if(storage.hasOwnProperty('bindType')){
      mesh.userData.bindType=storage.bindType
      mesh.userData.bindDevice=storage.bindDevice
      mesh.userData.bindUrl=storage.bindUrl
    }else{
      mesh.userData.bindType=false
      mesh.userData.bindUrl={url:'',loop:1}
      mesh.userData.bindDevice={device:'',devicevar:''}
    }
    if(storage.hasOwnProperty('bindEvent')){
      mesh.userData.bindEvent=storage.bindEvent
    }else{
      mesh.userData.bindEvent={event:'click',method:'',url:''}
    }
  }
  getStorage(mesh) {
        return {
          bindDevice:mesh.userData.bindDevice,
          bindEvent:mesh.userData.bindEvent,
          bindType:mesh.userData.bindType,
          bindUrl:mesh.userData.bindUrl,
          params:mesh.userData.params
        }
  }
}

import {http} from '@/utils/http/service'
import { Modal } from 'ant-design-vue'
import {h} from 'vue'
import SceneIframe from '../components/sceneiframe.vue'
export class DomElement extends CustomMould{
  update(mesh,data){
      //update内不能包含this,必需要独立调用
  }
  getData(mesh){
    let that=this
      if(mesh.userData.hasOwnProperty('bindType')&&mesh.userData.bindType==false){
          if(mesh.userData.hasOwnProperty('bindUrl')&&mesh.userData.bindUrl){
            if(mesh.userData.bindUrl.url){
              http.get(mesh.userData.bindUrl.url,{}).then(res=>{
                  if(res.state==1&&mesh.hasOwnProperty('update')){
                    mesh.userData.params.state=true
                    mesh.update(mesh,res.data)
                  }
              })
            }
            if(mesh.userData.bindUrl.loop>0){
              setTimeout(()=>{that.getData(mesh)},mesh.userData.bindUrl.loop*1000)
            }
          }
        }
  }
  create(storage:Object,threeEditor) {
    if(storage&&storage.params){
      this.params= Object.assign(this.params,storage.params)
    }
    var container=this.createDom()
    // 构建3D对象
      var mesh;

     if(this.params.use3d){
          mesh=new CSS3DObject(container)
     }else{
         mesh=new CSS2DObject(container)
         mesh.center.set(0.5,1)
     }
     mesh.update=this.update
     if(storage){
      mesh.userData=Object.assign(mesh.userData,storage)
     }
     mesh.userData['params']=this.params
     let that=this

     if(window.isEdit){
        container.onclick=()=>{
          console.info('dom点击')
           threeEditor.transformControls.attach(mesh)
        }
      }else{
        container.onclick=()=>{that.meshEvent(mesh)}
        this.getData(mesh)
     }

     return mesh
  }
  meshEvent(mesh){
      if(mesh.userData.hasOwnProperty('bindEvent')&&mesh.userData.bindEvent.url){
          if(mesh.userData.bindEvent.method=='popwin'){
            var m=  Modal.info({
                title:null,
                footer:null,
                icon:null,
                maskClosable:true,
                wrapClassName:'popwin',
                width:'70vw',
                content:h('iframe',{src:mesh.userData.bindEvent.url,frameborder:0,style:'width:100%;height:70vh;'}),
                onCancel(){
                  m.destroy()
                }
              })
          }else{
            var a= document.createElement('a')
            a.setAttribute('href',mesh.userData.bindEvent.url)
            a.setAttribute('target','_blank')
            document.appendChild(a)
            a.click()
            a.remove()
          }
      }
  }
  createDom(){
    var container=createContainer()
    return container
  }
  createContainer(){
    // 创建根容器
     const container = document.createElement("div")
     container.className="dom-container"
     container.style.cursor="pointer"
     container.style.pointerEvents = 'auto'
     return container
  }
}
export const svgIcons={
  temp:`<svg t="1756197524467" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3466" width="26" height="26" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M543.096963 630.338444V355.665267c0-16.698369-13.598672-30.297041-30.297041-30.297041h-2.399766c-16.298408 0-29.397129 13.198711-29.397129 29.397129v275.573089c-45.195586 13.098721-78.292354 53.494776-78.292354 101.690069 0 58.894249 48.895225 106.589591 109.389317 106.589591 60.394102 0 109.289327-47.795332 109.289327-106.589591-0.09999-48.195293-33.196758-88.491358-78.292354-101.690069zM703.981252 508.650327c-6.799336-5.599453-10.798945-13.198711-10.798946-20.997949V177.082707C693.182306 79.392247 611.890245 0 512 0c-99.890245 0-181.182306 79.392247-181.182306 177.082707v301.77053c0 13.098721-5.399473 25.197539-14.698565 33.096768-65.493604 55.2946-102.989942 135.586759-102.989942 220.178498 0 160.884289 134.086906 291.871497 298.970803 291.871497s298.970804-130.887218 298.970804-291.871497C810.970804 645.536959 771.974612 564.044917 703.981252 508.650327zM512 931.309052c-112.988966 0-204.780002-89.39127-204.780002-199.280539 0-68.493311 35.796504-131.487159 95.690655-168.383556l14.498584-8.899131c4.699541-2.899717 7.599258-8.099209 7.599258-13.598672V177.082707c0-46.59545 39.096182-84.491749 87.091495-84.491749 47.995313 0 87.091495 37.896299 87.091495 84.491749v364.064447c0 5.499463 2.899717 10.698955 7.599258 13.598672l14.498584 8.899131c59.894151 36.896397 95.590665 99.790255 95.590665 168.383556-0.09999 109.889269-91.991017 199.280539-204.879992 199.280539z" fill="#000" p-id="3467"></path></svg>`,
  co2:'<svg t="1756382617048" class="icon" viewBox="0 0 1443 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2521" xmlns:xlink="http://www.w3.org/1999/xlink" width="180.375" height="128"><path d="M769.389567 468.381947q-43.709386 0-43.68329 68.578069v106.624806q0 68.030071 42.613389 68.056166 44.779287 0 44.727096-65.498841v-104.719859q0.130476-73.066436-43.657195-73.040341z" fill="#040000" p-id="2522"></path><path d="M1379.181163 494.920721a335.583701 335.583701 0 0 0-141.696695-111.034887C1184.224255 160.14597 983.082796 0 750.548865 0a500.818226 500.818226 0 0 0-481.768763 365.045131 333.835325 333.835325 0 0 0-268.780102 326.189445c0 183.344563 149.159909 332.713234 332.713234 332.713234h778.183634c183.344563 0 332.713234-149.159909 332.713234-332.713234a330.41686 330.41686 0 0 0-64.428939-196.313855z m-784.055045 233.447261q-21.058791 32.958181-72.1792 32.958182-60.38419 0-83.948116-31.314187t-23.302974-103.858719v-69.569685q0-77.737468 24.372876-107.694707c16.439948-20.041079 42.404628-30.192095 77.920134-30.192095q50.102699 0 72.387962 26.799725c14.874239 17.875182 22.259168 45.431666 22.259167 82.878214h-60.410285q0-30.400856-6.236742-45.170714t-23.48564-14.743763q-43.474529 0-43.448434 68.499783v106.624806q0 36.794169 11.116536 52.451263t32.749421 15.657093c10.855585 0 18.866797-5.453888 23.981448-16.518233s7.828547-30.139905 7.828546-57.148391h61.480187q-0.104381 57.383247-21.084886 90.341428z m281.305777-101.771106q0 72.857674-23.329069 103.858719t-82.878214 30.844474q-57.85296 0-82.878214-29.565811t-25.025254-105.554905v-65.49884q0-81.155934 24.816493-111.530695t82.25193-30.400856q64.220178 0 85.644301 34.236844t21.398027 107.694707z m148.742387 97.621977v30.139904h-112.835453c0.574093-19.23213 2.609516-34.680462 6.602075-46.292806s14.874239-27.165057 33.166942-46.449376l18.083943-18.997274a92.559517 92.559517 0 0 0 15.396142-19.127749 43.109197 43.109197 0 0 0 3.966464-20.510792c0-15.94414-6.158457-23.955353-18.579751-23.955353-8.794067 0-14.535002 2.766086-17.144517 8.29826s-3.757702 15.448332-3.757703 30.139904h-36.011314v-8.298259q0-60.201524 56.522107-60.201524c19.28432 0 33.61056 5.219031 43.109197 15.396142a53.155832 53.155832 0 0 1 14.300145 37.86407c0 20.328126-8.428735 39.142733-25.442777 56.339441l-29.278764 30.505237q-20.067175 20.510792-20.067175 35.150175z" fill="#000" p-id="2523"></path></svg>',
  ch4:'<svg t="1756382699963" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3533" xmlns:xlink="http://www.w3.org/1999/xlink" width="128" height="128"><path d="M512 0C240.64 0 22.016 218.112 22.016 489.984c0 129.024 49.152 253.952 142.336 347.136 22.016 22.016 49.152 44.544 75.776 62.464 4.608 4.608 13.312 8.704 17.92 8.704v71.168c0 26.624 17.92 44.544 44.544 44.544h418.304c22.016 0 44.544-17.92 44.544-44.544v-71.168c4.608-4.608 13.312-8.704 17.92-8.704 26.624-17.92 53.248-39.936 75.776-62.464 93.696-93.696 142.336-213.504 142.336-347.136C1001.984 218.112 783.36 0 512 0zM191.488 489.984c0-75.776 57.856-133.632 133.632-133.632 13.312 0 22.016 4.608 31.232 13.312L445.44 458.752c8.704 8.704 13.312 17.92 13.312 31.232 0 75.776-57.856 133.632-133.632 133.632s-133.632-58.368-133.632-133.632z m418.304 284.672c-17.92 17.92-44.544 17.92-62.464 0l-35.84-31.232-35.84 35.84c-8.704 8.704-22.016 13.312-31.232 13.312-13.312 0-22.016-4.608-31.232-13.312-17.92-17.92-17.92-44.544 0-62.464l66.56-66.56c17.92-17.92 44.544-17.92 62.464 0l66.56 62.464c18.944 17.408 18.944 44.032 1.024 61.952z m89.088-151.552c-75.776 0-133.632-57.856-133.632-133.632 0-13.312 4.608-22.016 13.312-31.232l89.088-89.088c8.704-8.704 17.92-13.312 31.232-13.312 75.776 0 133.632 57.856 133.632 133.632s-62.464 133.632-133.632 133.632z" p-id="3534"></path></svg>',
  location:'<svg t="1756455608128" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2462" xmlns:xlink="http://www.w3.org/1999/xlink" width="128" height="128"><path d="M512 64C317.92 64 160 221.92 160 416c0 187.36 315.424 520.032 328.832 534.08C494.88 956.448 503.264 960 512 960c0.224 0 0.48 0 0.704 0 8.992 0 17.472-4.192 23.392-10.944l109.216-125.12C790.432 646.176 864 508.928 864 416 864 221.92 706.08 64 512 64zM512 576c-88.384 0-160-71.616-160-160s71.616-160 160-160 160 71.616 160 160S600.384 576 512 576z" p-id="2463"></path></svg>',
  camara:'<svg t="1757911128599" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3692" xmlns:xlink="http://www.w3.org/1999/xlink" width="128" height="128"><path d="M109.202286 658.285714V515.876571L0 498.834286V1024l109.275429-37.302857v-229.961143h174.08L358.4 641.462857 262.802286 583.68l-44.324572 78.043429H109.202286v-3.364572zM1024 515.876571L242.322286 0H153.6L30.72 193.389714v64.512l699.757714 454.729143 58.002286-6.802286L1024 515.803429zM30.72 298.569143v101.814857l706.56 448h64.877714l30.72-34.011429 30.72-98.377142q-88.795429 64.438857-95.597714 64.438857-30.72-23.771429-737.28-481.792z" p-id="3693"></path></svg>',
  hotcamara:'<svg t="1757911176330" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5554" xmlns:xlink="http://www.w3.org/1999/xlink" width="128" height="128"><path d="M996.09098 137.59749l7.529412 15.339922-598.096314 356.673255-3.754666-21.684706 9.115608 56.099137-10.721883 44.975686-18.251294-7.429019 9.135686-38.088785-5.381019-41.281255L26.824784 397.95451l10.721883-16.404079 364.222745 106.37553 594.321568-350.328471-60.054588-52.404706L689.272471 0 9.115608 387.915294 0 423.333647l8.031373 39.152941 12.348235 3.192471 2.148392-20.118588-4.296784 100.030745 38.630902 66.660392L301.979608 705.957647l77.241725-26.463372v3.694431l30.579451-16.404079v196.86902h0.52204c-0.522039 1.064157-0.522039 1.586196-0.52204 2.650353 0 13.231686 31.643608 24.857098 78.848 31.221961v41.803294c-35.940392 8.473098-59.552627 22.226824-59.552627 37.566745 0 25.941333 65.977725 47.104 147.516235 47.104s147.516235-21.162667 147.516235-47.104c0-15.339922-23.592157-29.113725-59.532549-37.566745V897.505882c47.184314-6.364863 78.848-17.990275 78.848-31.22196 0-1.064157-0.542118-1.606275-0.542117-2.650353h0.542117V490.034196l-332.579137 176.228392v-15.861961l332.579137-178.356705v17.990274l263.910902-146.572549V196.848941L1024 193.696627l-27.90902-56.099137zM120.711529 591.10902c-27.90902 0-50.416941-28.049569-50.416941-62.443922 0-34.394353 22.528-62.443922 50.416941-62.443922 27.90902 0 50.416941 28.049569 50.416942 62.443922 0 34.394353-22.528 62.443922-50.416942 62.443922z m140.006902 43.409568c-27.90902 0-50.43702-28.049569-50.437019-62.443921 0-34.414431 22.548078-62.443922 50.437019-62.443922s50.416941 28.02949 50.416942 62.443922c0 34.394353-22.528 62.443922-50.416942 62.443921z" p-id="5555"></path></svg>',
  volum:'<svg t="1758520510223" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4199" xmlns:xlink="http://www.w3.org/1999/xlink" width="128" height="128"><path d="M955.733333 464.213333c-6.997333 0-13.824-2.048-19.968-6.485333l-404.48-291.84c-11.434667-8.362667-26.965333-8.362667-38.4 0L88.234667 457.728c-15.189333 11.093333-36.522667 7.509333-47.616-7.68-11.093333-15.36-7.509333-36.693333 7.68-47.616l404.48-292.010667c35.328-25.6 82.944-25.6 118.272 0l404.48 291.84c15.36 11.093333 18.773333 32.426667 7.68 47.616-6.485333 9.386667-16.896 14.336-27.477334 14.336z" fill="#333333" p-id="4200"></path><path d="M76.8 394.922667v468.992c0 37.717333 30.549333 68.266667 68.266667 68.266666h733.866666c37.717333 0 68.266667-30.549333 68.266667-68.266666V394.922667h-870.4z m590.336 409.941333H356.864c-18.773333 0-34.133333-15.36-34.133333-34.133333s15.36-34.133333 34.133333-34.133334h310.272c18.773333 0 34.133333 15.36 34.133333 34.133334s-15.36 34.133333-34.133333 34.133333z m0-107.178667H356.864c-18.773333 0-34.133333-15.36-34.133333-34.133333s15.36-34.133333 34.133333-34.133333h310.272c18.773333 0 34.133333 15.36 34.133333 34.133333s-15.36 34.133333-34.133333 34.133333z m0-107.178666H356.864c-18.773333 0-34.133333-15.36-34.133333-34.133334s15.36-34.133333 34.133333-34.133333h310.272c18.773333 0 34.133333 15.36 34.133333 34.133333s-15.36 34.133333-34.133333 34.133334z" fill="#333333" p-id="4201"></path></svg>'
}
